import { combineReducers } from 'redux';

import { CHANGE_REFERRAL_DATA } from '../actions/auth/constants';
import createReducer from '../utils/createReducer';

// FIXME this looks more like an entity
const referral = createReducer(
  {
    code: '',
    id: null,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    logo_url: '',
    name: '',
  },
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [CHANGE_REFERRAL_DATA]: (draft, { payload }) => payload.referral,
  }
);

export default combineReducers({
  referral,
});
